import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import PageContainer from '../containers/PageContainer';
import PageTitleCard from '../cards/PageTitleCard';
import PageTitleText from '../texts/PageTitleText';
import ResponsiveModal from '../modal/ResponsiveModal';
import SmallButton from '../buttons/SmallButton';
import RestaurantSettings from '../restaurant/RestaurantSettings';
import UserContext from '../contexts/UserContext';

type Props = {}

const NewRestaurantPage = (props: Props) => {
    const { t } = useTranslation();
    const { restaurantSettings } = useContext(UserContext);
    const [alertOpen, setAlertOpen] = useState(false);

    useEffect(() => {
        document.title = `QuickPick - ${t("navigation.new_restaurant")}`;
    }, [t("navigation.new_restaurant")]);

    useEffect(() => {
        if (restaurantSettings.length === 0) {
            setAlertOpen(true);
        }
    }, [restaurantSettings])

    return (
        <>
            <PageContainer>
                <PageTitleCard>
                    <PageTitleText>
                        {t("navigation.new_restaurant")}
                    </PageTitleText>
                </PageTitleCard>
                <RestaurantSettings
                    isNew={true}
                />
            </PageContainer>
            <ResponsiveModal
                open={alertOpen}
                handleClose={() => { }}
                minWidth='500px'
            >

                <div className="w-max-[400px] px-3">
                    <div className="text-center font-bold text-primary-dark text-[20px]">
                        {t("auth.no_restaurant_title")}
                    </div>
                    <div className="mt-3">
                        {t("auth.no_restaurant_text")}
                    </div>
                    <div className="mt-3 font-bold text-primary">
                        {t("auth.no_restaurant_alt")}
                    </div>
                    <div className="mt-3 text-center">
                        <SmallButton
                            variant="strike"
                            onClick={() => setAlertOpen(false)}
                            fullWidth
                        >
                            {t("common.create_restaurant")}
                        </SmallButton>
                    </div>
                </div >
            </ResponsiveModal >
        </>

    )
}

export default NewRestaurantPage